import TaskForm, { TaskField } from "../TaskForm"; 
import ParcelService from "../../../services/parcelService";
import { HarvestTask } from "../../../interfaces/HarvestTask";

interface CreateEntryFormProps {
    onSave: (newEntry: HarvestTask) => void;
    parcelId: number;
    cycleId: number;
    isNew: boolean;
    task?: HarvestTask;
    readOnly?: boolean;
}

export default function HarvestCreateForm (props: CreateEntryFormProps){
    const parcelService = new ParcelService();

    const fields: TaskField[] = [
        { name: "outputPerParcel", label: "Ertrag (pro/ha)", type: "number", required: true },
        { name: "date", label: "Datum", type: "date", required: true },
        { name: "note", label: "Notizen", type: "textarea" }
    ] as const;

    const defaultState: HarvestTask = {
        id: "",
        outputPerParcel: 0,
        date: new Date(),
        note: ""
    };

    return (
        <TaskForm<HarvestTask>
            title="Ernte"
            fields={fields}
            isNew={props.isNew}
            task={props.task}
            defaultState={defaultState}
            onSubmit={async (data) => {
                if (props.isNew) {
                    await parcelService.createHarvestTask(props.parcelId, props.cycleId, data);
                } else {
                    await parcelService.updateHarvestTask(props.parcelId, props.cycleId, Number(data.id), data);
                }
                await props.onSave(data);
            }}
            readOnly={props.readOnly}
        />
    );
};
